
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-da808a62&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Brand.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Brand.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-da808a62!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Brand.vue"),
  /* scopeId */
  "data-v-da808a62",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Brand.vue
// module id = 928
// module chunks = 40